import request from '@/utils/request'

export function getConfigs() {
  return request({ url: '/admin/configs', method: 'get' })
}
export function getSiteConfig(lang) {
  return request({ url: '/admin/configs/site', method: 'get', params: { lang } })
}
export function saveConfig(data) {
  return request({ url: '/admin/configs', method: 'put', data })
}
